import { Interpolation } from "@emotion/core";
import { grid } from "../../../../design-tokens/grid";
import { Device } from "../../../../design-tokens/media-queries";

const timeline: Interpolation = {
  marginBottom: grid(3),

  [Device.DesktopTablet]: {
    marginBottom: grid(4),
  },
};

const styles = {
  timeline,
};

export default styles;
